import React from 'react';

const SubscriptionMessage = ({ message }) => {
	return <div className='subscription__message'>{message.text}</div>;
};

export default SubscriptionMessage;
